// API response type definitions
export interface Pagination {
  total: number;
  has_more: boolean;
  page?: number;
  per_page?: number;
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  pagination?: Pagination;
  message?: string;
}

// Legacy response format (for backward compatibility)
export interface LegacyApiResponse<T> {
  data: T;
  total?: number;
}

// Combined response type for gradual migration
export type CombinedApiResponse<T> = ApiResponse<T> | LegacyApiResponse<T>;

// Device related types
export interface AddDeviceRequest {
  model: string;
  serial_number: string;
  hardware_version?: string;
  firmware_version?: string;
  is_active: boolean;
}

// Song assignment type
export interface AssignSongRequest {
  song_id: string;
}

// Type guard to check if response is new format
export function isNewApiResponse<T>(
  response: CombinedApiResponse<T>
): response is ApiResponse<T> {
  return "success" in response;
}

// Helper function to normalize response
export function normalizeApiResponse<T>(
  response: CombinedApiResponse<T>
): ApiResponse<T> {
  if (isNewApiResponse(response)) {
    return response;
  }

  // Convert legacy format to new format
  return {
    success: true,
    data: response.data,
    pagination: response.total
      ? { total: response.total, has_more: false }
      : undefined,
  };
}
